"use client";

import { useRouter } from "next/router";
import { useUser } from "~/modules/user/hooks/useUser";
import { useEffect } from "react";
import { Routes } from "~/routes";

// // // //

/**
 * AUTH_REDIRECT_SESSION_STORAGE_KEY
 * Key for storing the desired redirect path in sessionStorage
 */
export const AUTH_REDIRECT_SESSION_STORAGE_KEY = "auth-redirect-path";

/**
 * AuthRedirectManager
 * Handles user authentication redirect after authentication is complete
 */
export function AuthRedirectManager() {
    const router = useRouter();
    const { isLoggedIn } = useUser();

    // Handle post-authentication redirect from sessionStorage
    useEffect(() => {
        if (isLoggedIn && router.pathname === Routes.home) {
            // Get the stored redirect path from sessionStorage
            const storedRedirectPath = sessionStorage.getItem(
                AUTH_REDIRECT_SESSION_STORAGE_KEY,
            );

            // Do nothing if no redirect path is stored
            if (!storedRedirectPath) {
                return;
            }

            // Do nothing if the redirect path is the home page
            if (storedRedirectPath === Routes.home) {
                return;
            }

            // Remove the stored redirect path from sessionStorage
            sessionStorage.removeItem(AUTH_REDIRECT_SESSION_STORAGE_KEY);

            // Redirect user to the stored redirect path
            router.push(storedRedirectPath);
        }
    }, [isLoggedIn, router]);

    return null;
}
